export const cards = {
  freeWithGold: "Free with Gold",
  customCard: {
    ribbonFacetText: {
      exclusive: "Exclusive",
      staffPick: "Staff Pick",
      verticals: "Verticals",
      originals: "Originals",
      comingSoon: "Coming Soon",
      newArrival: "New Arrival",
    },
    buttonText: {
      continueReading: "Continue Reading",
      startReading: "Start Reading",
      follow: "Follow",
      following: "Following",
      viewProfile: "View Profile",
      viewList: "View List",
      learnMore: "Learn More",
      preview: "Preview",
      freeWithGold: "Free with Gold",
      buyNow: "Buy Now",
      seeDetails: "See Details",
    },
    readingListEyebrow: "Reading List",
    comicReadingStyle: {
      panelToPanel: "Panel To Panel",
      verticalScroll: "Vertical Scroll",
      printLayout: "Print Layout",
    },
    comicUpdateFrequency: {
      weekly: "Weekly",
      biWeekly: "Bi-Weekly",
      monthly: "Monthly",
      biMonthly: "Bi-Monthly",
      quarterly: "Quarterly",
      twiceAYear: "Twice A Year",
      yearly: "Yearly",
      updatedLastMonth: "Updated Last Month",
      updates: "Updates",
      on: "on {{day}}",
      daysOfWeek: {
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
        "7": "Sunday",
      },
    },
  },
  expandedContentSection: {
    close: "Close",
    share: "Share",
    backToHome: "Back to home",
  },
  contentReleaseCalendar: {
    showingCards: "Showing {{cardsShown}} out of {{totalCards}}",
  },
  facets: {
    leaving: "Leaving",
  },
  releaseCardMenu: {
    startReading: "Start reading",
    continueReading: "Continue reading",
    previewRelease: "Preview release",
    releaseDetails: "Release details",
    share: "Share",
  },
  unlockReleaseCard: {
    buy: "Buy",
    freeWithGold: "Free with Gold",
    pdf: "PDF",
  },
  purchasedContentBadge: {
    youPurchasedThis: "You purchased this",
    purchased: "Purchased",
  },
  goldRewardBadge: {
    goldReward: "Gold Reward",
  },
  bundleCard: {
    pagesInReleases: "{{totalPages}} pages in {{totalReleases}} releases",
  },
};
